import React from 'react';

import { PeopleIcon } from '@vlabs/icons';
import { usePeopleCountThresholdInfo } from '@vlabs/shared/hooks';
import { CopyButton, Tag } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { BaseVideoAnalyticsDetails } from '../components/BaseVideoAnalyticsDetails';
import st from '../components/BaseVideoAnalyticsDetails.module.sass';
import type { AnalyticDetailsEvent } from '../types';

type CrowdEvent = AnalyticDetailsEvent & {
  event: AnalyticDetailsEvent['event'] & {
    overview?: AnalyticDetailsEvent['event']['overview'] & {
      people_coordinates?: Record<string, unknown>[];
    };
    people_count?: number;
  };
};

export function CrowdDetails({ event }: { event: CrowdEvent }): React.JSX.Element {
  const { t } = useTranslation();
  const { label: thresholdLabel } = usePeopleCountThresholdInfo(event);
  const coordinates = event.event.overview?.people_coordinates ?? [];
  const threshold = thresholdLabel ? ` (${thresholdLabel})` : '';

  return (
    <BaseVideoAnalyticsDetails
      detections={coordinates}
      detectionType="point"
      event={event}
      extraRows={(
        <React.Fragment>
          <div
            className={st.RowTitle}
            data-testid="workspace.analyticEventDetails.extraRowTitle"
          >
            {t('videoAnalytics:crowdAnalyticDetails.workspace.faces coordinates')}
          </div>
          <div
            className={st.RowData}
            data-testid="workspace.analyticEventDetails.extraRowData"
          >
            <CopyButton
              className={st.CopyButton}
              data-testid="workspace.analyticEventDetails.copyButton"
              label={t('videoAnalytics:crowdAnalyticDetails.workspace.copy')}
              size="small"
              value={coordinates}
            />
          </div>
        </React.Fragment>
      )}
      tags={(
        <Tag
          data-testid="workspace.analyticEventDetails.extraTagType"
          icon={<PeopleIcon />}
          kind="neutral"
          size="large"
          value={`${event.event.people_count} ${t('videoAnalytics:crowdAnalyticDetails.workspace.tag.label')}${threshold}`}
        />
      )}
      title={t('videoAnalytics:crowdAnalyticDetails.workspace.title')}
    />
  );
}
